import React from "react";

function Footer() {
  return <footer>&copy; Satta Matka Games - {new Date().getFullYear()}</footer>;
}

export default Footer;
